// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Rxjs from "../Rxjs.bs.jsx";
import * as Rxjs$1 from "rxjs";
import * as Reactfire from "reactfire";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as Stdlib_Promise from "@rescript/runtime/lib/es6/Stdlib_Promise.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function share(data) {
  try {
    return Stdlib_Promise.$$catch(navigator.share(data), err => {
      if (err.RE_EXN_ID !== "JsExn") {
        return Promise.reject(err);
      }
      let match = Stdlib_JsExn.name(err._1);
      if (match === "AbortError") {
        return Promise.resolve();
      } else {
        return Promise.reject(err);
      }
    }).then(() => Promise.resolve("Share"));
  } catch (raw_exn) {
    let exn = Primitive_exceptions.internalToException(raw_exn);
    if (exn.RE_EXN_ID === "JsExn") {
      return navigator.clipboard.writeText(data.url).then(() => Promise.resolve("Clipboard"));
    }
    throw exn;
  }
}

function mediaRx(query) {
  let mediaQuery = window.matchMedia(query);
  return Rxjs$1.fromEvent(mediaQuery, "change").pipe(Rxjs$1.startWith(mediaQuery), Rxjs$1.map((list, param) => list.matches));
}

let standaloneModeRx = mediaRx("(display-mode: standalone)");

function useIsStandaloneMode() {
  return Reactfire.useObservable("isStandaloneMode", standaloneModeRx);
}

let isOnlineRx = Rxjs.op(Rxjs$1.merge(Rxjs$1.fromEvent(window, "online").pipe(Rxjs$1.map((param, param$1) => true)), Rxjs$1.fromEvent(window, "offline").pipe(Rxjs$1.map((param, param$1) => false))), Rxjs$1.startWith(window.navigator.onLine));

function useIsOnline() {
  return Reactfire.useObservable("isOnline", isOnlineRx);
}

let supportsPlatformWebAuthnCache = {
  contents: undefined
};

let supportsPlatformWebAuthn = (!window.PublicKeyCredential
  ? Promise.resolve(false)
  : window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable()).then(result => {
  supportsPlatformWebAuthnCache.contents = result;
  return Promise.resolve(result);
});

function useSuportsPlatformWebauthn() {
  let result = supportsPlatformWebAuthnCache.contents;
  if (result !== undefined) {
    return result;
  }
  throw supportsPlatformWebAuthn;
}

export {
  share,
  mediaRx,
  standaloneModeRx,
  useIsStandaloneMode,
  isOnlineRx,
  useIsOnline,
  supportsPlatformWebAuthnCache,
  supportsPlatformWebAuthn,
  useSuportsPlatformWebauthn,
}
/* standaloneModeRx Not a pure module */
